import * as CONST from './const'

const initState = {
  user: null,
  apiKey: null,
  formSubmitting: false,
  formSubmitted: false,
  errorMessage: '',
  passwordResetEmail: '',
  isCodeAndHashValid: false,
  signUp: {
    email: '',
    firstName: '',
    lastName: '',
    providerId: '',
    providerType: '',
  },
}

export function auth(state = initState, action) {
  switch (action.type) {
    case CONST.AUTH_LOGIN_ERROR:
      return {
        ...state,
        user: null,
        formSubmitting: false,
        errorMessage: action.payload.errorMessage,
      }

    case CONST.AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        apiKey: action.payload.apiKey,
        formSubmitting: false,
        errorMessage: '',
      }

    case CONST.AUTH_LOGIN:
      return {
        ...state,
        formSubmitting: true,
        errorMessage: '',
      }

    case CONST.AUTH_LOGOUT:
      return {
        ...state,
        user: null,
        apiKey: null,
      }

    case CONST.AUTH_REQUEST_RESET_PASSWORD:
      return {
        ...state,
        formSubmitting: true,
        errorMessage: '',
      }

    case CONST.AUTH_REQUEST_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        formSubmitted: true,
        errorMessage: '',
        passwordResetEmail: action.payload.email,
      }

    case CONST.AUTH_REQUEST_RESET_PASSWORD_ERROR:
      return {
        ...state,
        formSubmitting: false,
        errorMessage: action.payload.errorMessage,
      }

    case CONST.AUTH_INIT_FORGOT_PASSWORD_FORM:
      return {
        ...state,
        formSubmitted: false,
        errorMessage: '',
        passwordResetEmail: '',
      }

    case CONST.AUTH_CHECK_CODE_AND_HASH_SUCCESS:
      return {
        ...state,
        isCodeAndHashValid: true,
        errorMessage: '',
      }

    case CONST.AUTH_CHECK_CODE_AND_HASH_ERROR:
      return {
        ...state,
        isCodeAndHashValid: false,
        errorMessage: action.payload.errorMessage,
      }

    case CONST.AUTH_RESET_PASSWORD:
      return {
        ...state,
        formSubmitting: true,
        formSubmitted: false,
        errorMessage: '',
      }

    case CONST.AUTH_RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        user: action.payload.user,
        apiKey: action.payload.apiKey,
        formSubmitting: false,
        formSubmitted: true,
      }

    case CONST.AUTH_RESET_PASSWORD_ERROR:
      return {
        ...state,
        formSubmitted: false,
        formSubmitting: false,
        errorMessage: action.payload.errorMessage,
      }

    default:
      return state
  }
}
